import React from "react";
import Title from "../Title/Title";
import {
  IoRocketOutline,
  IoArrowUndoOutline,
  IoTicketOutline,
} from "react-icons/io5";
import { BsTelephone } from "react-icons/bs";

const Bio = () => {
  return (
    <>
      <Title title="Our Services" />
      <section className="service">
        <div className="service-container">
          <div className="service-item">
            <div className="service-icon">
              <IoRocketOutline />
            </div>

            <div className="service-content">
              <h3 className="service-title">Worldwide Delivery</h3>
              <p className="service-desc">For Order Over $100</p>
            </div>
          </div>
          <div className="service-item">
            <div className="service-icon">
              <BsTelephone />
            </div>

            <div className="service-content">
              <h3 className="service-title">Best Online Support</h3>
              <p className="service-desc">Hours: 8AM - 11PM</p>
            </div>
          </div>

          <div className="service-item">
            <div className="service-icon">
              <IoArrowUndoOutline />
            </div>

            <div className="service-content">
              <h3 className="service-title">Return Policy</h3>
              <p className="service-desc">Easy & Free Return</p>
            </div>
          </div>

          <div className="service-item">
            <div className="service-icon">
              <IoTicketOutline />
            </div>

            <div className="service-content">
              <h3 className="service-title">30% money back</h3>
              <p className="service-desc">For Order Over $100</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Bio;
